import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getCoachingNotesListReq,
  getCoachingNotesListReqResponseClear,
  getLeaderBoardReq,
} from "../../redux/user/actions";
import {
  SessionKeys,
  commonApiReqDel,
  timezoneArea,
} from "../../utils/AppUtils";
import _ from "lodash";
import CoachAddModal from "./CoachAddModal";
import StaticUtils from "../../utils/StaticUtils";
import ShimmerNotification from "../Layouts/ShimmerNotification";
import Dropdown from "react-bootstrap/Dropdown";
import DatePicker from "react-datepicker";
import ConfirmModal from "../modal/ConfirmModal";
import {
  deleteCoachClear,
  deleteCoachReq,
  getRankStatus,
} from "../../redux/courses/actions";
import Loader from "../Loader/Loader";
import ShimmerForProfileTabs from "../Layouts/ShimmerForProfileTabs";
const CoachingNotesListComp = (props) => {
  const { key } = props;

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const section = params.get("section");
  const user_id = params.get("user_id");
  const isOther =
    localStorage.getItem(SessionKeys.USER_ID) === user_id ? "0" : "1"; //params.get("isOther");

  const dispatch = useDispatch();
  const coachingNotesListtRes = useSelector(
    (state) => state.user.coachingNotesList
  );
  const authBroker = useSelector((state) => state.auth.authBroker);
  const deleteCoachRes = useSelector((state) => state.courses.deleteCoachRes);
  const userDetailRes = useSelector((state) => state.user.userBroker);

  const [coachingNoteListData, setCoachingNoteListData] = useState([]);
  const [showAddCoachModal, setShowAddCoachModal] = useState(false);
  const [selectedCoachObj, setSelectedCoachObj] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [selectedSort, setSelectedSort] = useState("");

  const [confirmModal, setConfirmModal] = useState(false);
  const [currNoteId, setCurrNoteId] = useState("");
  const [timezone, setTimezone] = useState({});
  const [searchClick,setSearchClick] = useState(false);

  useEffect(() => {
    console.log("selectedSort: ", selectedSort, coachingNoteListData);
    if (!_.isEmpty(selectedSort) && !_.isEmpty(coachingNoteListData)) {
      let tempList = [];
      tempList = _.cloneDeep(coachingNoteListData);
      if (selectedSort === "title") {
        tempList.sort((a, b) => {
          const nameA = a.title.toUpperCase(); // ignore upper and lowercase
          const nameB = b.title.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      }
      if (selectedSort === "titleRev") {
        tempList.sort((a, b) => {
          const nameA = a.title.toUpperCase(); // ignore upper and lowercase
          const nameB = b.title.toUpperCase(); // ignore upper and lowercase
          if (nameA > nameB) {
            return -1;
          }
          if (nameA < nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      }if (selectedSort === "followUpTitle") {
        tempList.sort((a, b) => {
          const nameA = a.followup_title?.toUpperCase(); // ignore upper and lowercase
          const nameB = b.followup_title?.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      } if (selectedSort === "followUpTitleRev") {
        tempList.sort((a, b) => {
          const nameA = a.followup_title?.toUpperCase(); // ignore upper and lowercase
          const nameB = b.followup_title?.toUpperCase(); // ignore upper and lowercase
          if (nameA > nameB) {
            return -1;
          }
          if (nameA < nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      }
      if (selectedSort === "notes") {
        tempList.sort((a, b) => {
          const nameA = a.notes.toUpperCase(); // ignore upper and lowercase
          const nameB = b.notes.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      }
      if (selectedSort === "notesRev") {
        tempList.sort((a, b) => {
          const nameA = a.notes.toUpperCase(); // ignore upper and lowercase
          const nameB = b.notes.toUpperCase(); // ignore upper and lowercase
          if (nameA > nameB) {
            return -1;
          }
          if (nameA < nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      }
      if (selectedSort === "assigned_by") {
        tempList.sort((a, b) => {
          const nameA = a.assign_by.toUpperCase(); // ignore upper and lowercase
          const nameB = b.assign_by.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      }
      if (selectedSort === "assigned_byRev") {
        tempList.sort((a, b) => {
          const nameA = a.assign_by.toUpperCase(); // ignore upper and lowercase
          const nameB = b.assign_by.toUpperCase(); // ignore upper and lowercase
          if (nameA > nameB) {
            return -1;
          }
          if (nameA < nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
      } else if (selectedSort === "coach_date") {
        tempList.sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return (
            new Date(Number(a.start_date) * 1000) -
            new Date(Number(b.start_date) * 1000)
          );
        });
      } else if (selectedSort === "coach_dateRev") {
        tempList.sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return (
            new Date(Number(b.start_date) * 1000) -
            new Date(Number(a.start_date) * 1000)
          );
        });
      } else if (selectedSort === "follow_date") {
        tempList.sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return (
            new Date(Number(a.follow_up) * 1000) -
            new Date(Number(b.follow_up) * 1000)
          );
        });
      } else if (selectedSort === "follow_dateRev") {
        tempList.sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return (
            new Date(Number(b.follow_up) * 1000) -
            new Date(Number(a.follow_up) * 1000)
          );
        });
      }
      setCoachingNoteListData(tempList);
    }
  }, [selectedSort]);

  useEffect(() => {
    if (!_.isEmpty(timezone)) {
        setIsLoading(true);
        getCoachNotesDataReq();
      } 
  }, [ timezone,searchClick]);
  useEffect(()=>{
    if(_.isEmpty(searchValue)){
      getCoachNotesDataReq();
    }
  },[searchValue])
  useEffect(() => {
    getCoachNotesDataReq();
  }, [selectedMonth]);

  useEffect(() => {
    console.log("coachingNotesListtRes: ", coachingNotesListtRes);
    if (!_.isEmpty(coachingNotesListtRes)) {
      setIsLoading(false);
      if (coachingNotesListtRes?.status === "success") {
        let list = coachingNotesListtRes?.payload?.payload?.list;
        // for (const item of list) {
        //   item.notes = item.notes.replace("\n",'<br />')
        // }
        // console.log("List: ",list)
        setCoachingNoteListData(list);
        setSelectedSort("coach_date");
        dispatch(getCoachingNotesListReqResponseClear());
      } else {
        setCoachingNoteListData([]);
        dispatch(getCoachingNotesListReqResponseClear());
      }
    }
  }, [coachingNotesListtRes]);

  //get leader board
  const getCoachNotesDataReq = () => {
    setIsLoading(true);
    dispatch(
      getCoachingNotesListReq({
        module: "getCoachingNotesData",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          user_id:
            isOther === "1"
              ? user_id
              : localStorage.getItem(SessionKeys.USER_ID),
          search: searchValue,
          filter: moment(selectedMonth).format("YYYY"),
        },
      })
    );
  };

  const [deleteLoading, setDeleteLoading] = useState(false);
  const deleteCoach = (id) => {
    setDeleteLoading(true);
    commonApiReqDel("deleteCoachReq", dispatch, deleteCoachReq, {
      token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      id: id,
    });
  };

  useEffect(() => {
    if (!_.isEmpty(deleteCoachRes)) {
      setDeleteLoading(false);
      if (deleteCoachRes?.status === "success") {
        let data = deleteCoachRes?.payload?.payload;
        setConfirmModal(false);
        getCoachNotesDataReq();
        dispatch(deleteCoachClear({}));
      }
    }
  }, [deleteCoachRes]);

  useEffect(() => {
    // console.log('userDetailRes: ', userDetailRes)
    if (!_.isEmpty(userDetailRes?.payload?.payload)) {
      const userDetails = userDetailRes.payload.payload;
      const timezoneOffset = !_.isEmpty(userDetails.timezone) ? userDetails.timezone.replace(':', '') : '-0400'
      const area = timezoneArea(timezoneOffset)
      setTimezone(area)
    }
  }, [userDetailRes])

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      setSearchClick(!searchClick)
    }
  }

  return (
    <>
      <Loader start={deleteLoading} />
      <div className="profile-info-wrapper">
        <div className="profile-info-title d-flex flex-wrap justify-content-between gap-3 align-items-center">
          <div className="title-box">Coaching Notes</div>
          <div className="from-notes-wrapper">
            <div className="search-info">
              <div className="confirm-row m-0">
                <input
                  type="search"
                  id="search"
                  name="search"
                  className="form-control"
                  placeholder="search for coaching notes..."
                  value={searchValue}
                  onKeyDown={handleKeyDown}
                  onChange={(evt) => {
                    setSearchValue(evt.target.value);
                  }}
                />
                <button className="confirm-btn" onClick={()=>{setSearchClick(!searchClick)}}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.16667 1.66669C5.02454 1.66669 1.66667 5.02455 1.66667 9.16669C1.66667 13.3088 5.02454 16.6667 9.16667 16.6667C10.9375 16.6667 12.565 16.053 13.8481 15.0266L16.9107 18.0893C17.2362 18.4147 17.7638 18.4147 18.0893 18.0893C18.4147 17.7638 18.4147 17.2362 18.0893 16.9108L15.0266 13.8481C16.0529 12.565 16.6667 10.9375 16.6667 9.16669C16.6667 5.02455 13.3088 1.66669 9.16667 1.66669ZM3.33334 9.16669C3.33334 5.94503 5.94501 3.33335 9.16667 3.33335C12.3883 3.33335 15 5.94503 15 9.16669C15 12.3883 12.3883 15 9.16667 15C5.94501 15 3.33334 12.3883 3.33334 9.16669Z"
                      fill="black"
                    ></path>
                  </svg>
                  Search
                </button>
              </div>
              {/* <div className="input-text position-relative">
                <label htmlFor="search" className="input__label">
                  Search
                </label>
                <input
                  type="search"
                  id="search"
                  name="search"
                  className="input_field mr-2"
                  placeholder=" "
                  value={searchValue}
                  onChange={(evt) => {
                    setSearchValue(evt.target.value);
                  }}
                />
              </div> */}
            </div>
            <div className="datemonth-wrapper">
              <svg
                className="calshwo"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="#444444"
              >
                <path d="M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z"></path>
              </svg>
              <DatePicker
                id="datePick"
                selected={selectedMonth}
                showYearPicker
                dateFormat="yyyy"
                onChange={(date) => setSelectedMonth(date)}
              />
              <svg
                className="cursor-pointer dropcal"
                onClick={() => {
                  document.getElementById("datePick").click();
                }}
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.8" filter="url(#filter0_f_2341_22533)">
                  <ellipse cx="20" cy="20.001" rx="8" ry="8" fill="#444444" />
                </g>
                <circle
                  cx="18"
                  cy="18.0005"
                  r="12"
                  transform="rotate(-180 18 18.0005)"
                  fill="#FEF6D5"
                />
                <path
                  d="M22.6666 16.0013L17.9999 20.668L13.3333 16.0013"
                  stroke="#444444"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <defs>
                  <filter
                    id="filter0_f_2341_22533"
                    x="0"
                    y="0.000976562"
                    width="40"
                    height="40"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="BackgroundImageFix"
                      result="shape"
                    />
                    <feGaussianBlur
                      stdDeviation="6"
                      result="effect1_foregroundBlur_2341_22533"
                    />
                  </filter>
                </defs>
              </svg>
            </div>

            {isOther === "1" && (
              <div className="add-coaching">
                <button
                  onClick={() => {
                    setSelectedCoachObj({});
                    setShowAddCoachModal(true);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    fill="rgba(0,0,0,1)"
                  >
                    <path d="M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V4H5V20H19ZM8 7H16V9H8V7ZM8 11H16V13H8V11ZM8 15H16V17H8V15Z"></path>
                  </svg>
                  Add Coaching Notes
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="course-info-table">
          <table className="table mb-0 office_list table-striped video-list">
            <thead>
              <tr>
                <th
                  className={`cursor-pointer is-sort ${
                    selectedSort === "title" && "selected-sort"
                  }`}
                  onClick={() => {
                    if (selectedSort === "title") {
                      setSelectedSort("titleRev");
                    } else setSelectedSort("title");
                  }}
                >
                  Coaching Title
                </th>
                <th
                  className={`cursor-pointer is-sort ${
                    selectedSort === "notes" && "selected-sort"
                  }`}
                  style={{ minWidth: "300px" }}
                  onClick={() => {
                    if (selectedSort === "notes") {
                      setSelectedSort("notesRev");
                    } else setSelectedSort("notes");
                  }}
                >
                  Notes
                </th>
                <th
                  className={`cursor-pointer is-sort ${
                    selectedSort === "assigned_by" && "selected-sort"
                  }`}
                  onClick={() => {
                    if (selectedSort === "assigned_by") {
                      setSelectedSort("assigned_byRev");
                    } else setSelectedSort("assigned_by");
                  }}
                >
                  Assigned by
                </th>
                <th
                  className={`cursor-pointer is-sort ${
                    selectedSort === "coach_date" && "selected-sort"
                  }`}
                  onClick={() => {
                    if (selectedSort === "coach_date") {
                      setSelectedSort("coach_dateRev");
                    } else setSelectedSort("coach_date");
                  }}
                >
                  Coaching Date
                </th>
                <th className={`cursor-pointer is-sort ${
                  selectedSort === 'followUpTitle' && 'selected-sort'
                  }`} 
                  onClick={() => { if (selectedSort === "followUpTitle") {
                     setSelectedSort("followUpTitleRev")
                     } else setSelectedSort("followUpTitle")
                     }}
                  >
                     Follow-up Title
                </th>
                <th
                  className={`cursor-pointer is-sort ${
                    selectedSort === "follow_date" && "selected-sort"
                  }`}
                  onClick={() => {
                    if (selectedSort === "follow_date") {
                      setSelectedSort("follow_dateRev");
                    } else setSelectedSort("follow_date");
                  }}
                >
                  Follow-up
                </th>
                {isOther === "1" && (
                  <th
                    className={`action-del text-center`}
                    onClick={() => {
                      if (selectedSort === "follow_date") {
                        setSelectedSort("follow_dateRev");
                      } else setSelectedSort("follow_date");
                    }}
                  >
                    Action
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr className="not-found">
                  <td colSpan={6}>
                    {[1, 2, 3].map((m) => {
                      return (
                        <ShimmerForProfileTabs key={`notify-${m}-shimmer`} />
                      );
                    })}
                  </td>
                </tr>
              ) : coachingNoteListData.length > 0 ? (
                coachingNoteListData.map((item, index) => {
                  return (
                    <tr>
                      <td>{item.title}</td>
                      <td
                        className="cursor-pointer"
                        title={item.notes}
                        onClick={() => {
                          setSelectedCoachObj(item);
                          setShowAddCoachModal(true);
                        }}
                      >
                        <u
                          className="p_wrap "
                          dangerouslySetInnerHTML={{
                            __html: item.notes.slice(0, 85),
                          }}
                        ></u>
                        {item.notes.length > 85 ? "..." : ""}
                      </td>
                      <td>{item.assign_by}</td>
                      <td>
                        {moment(
                          StaticUtils.getDateFromTimeStamp(item.start_date),
                          "MM/DD/YYYY"
                        ).format("DD MMMM, YYYY")}
                      </td>
                      <td>{item.followup_title}</td>
                      <td>
                      {moment.unix(item.followup_start_dt).tz(timezone).format('DD MMMM YYYY, HH:mm - ')+moment.unix(item.followup_end_dt).tz(timezone).format('HH:mm')}
                      </td>

                      {isOther === "1" && (
                        <td className="text-center">
                          <span
                            className="cursor-pointer"
                            onClick={() => {
                              setCurrNoteId(item.id);
                              setConfirmModal(true);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="24"
                              height="24"
                              fill="rgba(255,0,0,1)"
                            >
                              <path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z"></path>
                            </svg>
                          </span>
                        </td>
                      )}
                    </tr>
                  );
                })
              ) : (
                <tr className="not-found">
                  <td colSpan={isOther==="1"?7:6}>
                    <img src="/images/telescope.svg" alt="Not Found" />
                    <p>No coaching yet.</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {showAddCoachModal ? (
        <CoachAddModal
          showAddCoachModal={showAddCoachModal}
          setShowAddCoachModal={setShowAddCoachModal}
          coachObj={selectedCoachObj}
          refreshList={getCoachNotesDataReq}
          timezone={timezone}
        />
      ) : (
        ""
      )}
      {confirmModal && (
        <ConfirmModal
          confirmModal={confirmModal}
          setConfirmModal={setConfirmModal}
          showModalMsg={"Are you sure you want to delete?"}
          isConfirm={true}
          confirmId={currNoteId}
          confirmAction={deleteCoach}
          noAction={() => {}}
        />
      )}
    </>
  );
};

export default CoachingNotesListComp;
